var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5V10.625M8.75 10.625L6.25 8.125M8.75 10.625L11.25 8.125M4.375 13.125C2.30393 13.125 0.625 11.4461 0.625 9.375C0.625 7.71421 1.70463 6.30558 3.20033 5.81266C3.15087 5.54933 3.125 5.27769 3.125 5C3.125 2.58375 5.08375 0.625 7.5 0.625C9.52602 0.625 11.2304 2.00217 11.7281 3.87146C11.9712 3.79261 12.2306 3.75 12.5 3.75C13.8807 3.75 15 4.86929 15 6.25C15 6.54012 14.9506 6.81869 14.8597 7.07777C16.0378 7.52538 16.875 8.66492 16.875 10C16.875 11.7259 15.4759 13.125 13.75 13.125H4.375Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowloadIcon);
export default __webpack_public_path__ + "static/media/dowload-icon.fe9f74d54ba305903652dafe12d12a85.svg";
export { ForwardRef as ReactComponent };